export default __webpack_public_path__ + "static/media/check.4bc61c17.svg";